const { NODE_ENV } = process.env

export const IS_DEV = NODE_ENV === 'development'

export const API_HOST = IS_DEV
    ? 'http://localhost:3000/graphql'
    : 'https://xn--299a14lu5ffxn.com';

